function saveChoice(sess, choices) {
    const {Choice} = sess;
    return Choice.create(choices)
}
 
function removeChoice(sess, id) {
    const {Choice} = sess;
    return Choice.withId(id).delete();
}

function selectChoice(sess, id) {
    const {Choice} = sess;
    if (!Choice.idExists(id)) {
        throw new Error(`there is'nt any choice with this id '${id}'`);
    }
    const targetChoice = Choice.withId(id)
    targetChoice.question.toModelArray()[0].choices.all().toModelArray().forEach(choice => {
        if (targetChoice.equals(choice)) {
            choice.update({isCheck: true});
        } else {
            choice.update({isCheck: false});
        }
    });
}

function deSelectChoice(sess, id) {
    const {Choice} = sess;
    if (!Choice.idExists(id)) {
        throw new Error("there is`nt any choice with this id");
    }
    const targetChoice = Choice.withId(id)
    targetChoice.update({isCheck: false});
}



export default {
    saveChoice,
    selectChoice,
    removeChoice,
    deSelectChoice,
}